import { useTranslation } from "react-i18next";
import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";
import { Pawn } from "./board/Pawn";

interface GameLoadingScreenProps {
  message?: string;
  showGrid?: boolean;
}

export function GameLoadingScreen({
  message,
  showGrid = true,
}: GameLoadingScreenProps) {
  const { t } = useTranslation();
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);

  return (
    <div
      className={`min-h-screen ${theme.bg} flex items-center justify-center font-sans relative`}
    >
      {showGrid && (
        <div
          aria-hidden="true"
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "radial-gradient(var(--color-ink) 2px, transparent 2.5px)",
            backgroundSize: "28px 28px",
          }}
        />
      )}

      <div className="relative flex flex-col items-center gap-5">
        <Pawn hopping className="w-14 h-14" />
        <span
          role="status"
          className={`font-display text-sm uppercase tracking-wide ${theme.text}`}
        >
          {message ?? t("components.loadingScreen")}
        </span>
      </div>
    </div>
  );
}
